<template>
  <div class="container">
    <section class="section intro">
      <div class="background">
        <img src="./../assets/images/home_banner.jpg" alt="background"/>
      </div>
      <div class="content">
        <p class="section-header" v-html="$translations.get('about_header')">Our team</p>
        <p class="section-title" v-html="$translations.get('about_title')">About Wagner - Hatfield</p>
      </div>
    </section>
    <section v-for="employee in employees" v-if="!!employee" class="section biography">
      <div class="background">
      </div>
      <div class="content">
        <div class="text">
          <p class="name">{{employee.Title}}</p>
          <p class="position">{{employee.ShortDescription}}</p>
          <p class="bio" v-html="employee.Description">
          </p>
        </div>
        <div class="picture">
          <img :src="`https://wagner-hatfield.com/administration/upload/article/${employee.Image}`" alt="picture"/>
        </div>
      </div>
    </section>
    <section v-if="!!ourName" class="section our-name">
      <div class="background">
      </div>
      <div class="content">
        <div class="big-title">
          WAGNER-HATFIELD
        </div>
        <div class="text-section">
          <p class="header">{{ourName.ShortDescription}}</p>
          <p class="title">{{ourName.Title}}</p>
          <div class="text">
            <div class="text-content" v-html="ourName.Description">
            </div>
            <div class="picture">
              <img :src="`https://wagner-hatfield.com/administration/upload/article/${ourName.Image}`" alt="picture"/>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-section :background="require('./../assets/images/home_footer.jpg')"/>
  </div>
</template>

<script>
  import FooterSection from "@/components/FooterSection";

  export default {
    name: 'About',
    metaInfo: {
      title: "About us"
    },
    components: {FooterSection},
    data: () => ({
      employees: [],
      ourName: null
    }),
    created: function () {
      let employees = this.$articles.allWhere("Slug", 'employee');
      this.employees = employees.sort((a, b) => a.Position > b.Position);
      this.ourName = this.$articles.where("Slug", "our-name");
    }
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .section {

    &.intro {

      .background {
        height: 100vh;

        &::after {
          content: '';
          display: block;
          @include absolute-stretch();
        }
      }

      .content {
        height: 50vh;
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        flex-direction: column;
        padding-left: 4em;
        padding-bottom: 4em;
        box-sizing: border-box;

        .section-header {
          text-align: left !important;
          opacity: 0;
        }

        .section-title {
          text-align: left !important;
          opacity: 0;
        }
      }
    }

    &.biography {

      .background {
        background: #fff;
      }

      .content {
        display: flex;
        flex-direction: row;
        justify-content: stretch;
        align-items: stretch;

        .text {
          flex: 1;
          padding: 4rem;

          .name {
            font-size: 1.5rem;
            margin: 0;
            color: rgba(0, 0, 0, 0.8);
            font-family: 'OpenSans-SemiBold', sans-serif;
          }

          .position {
            font-size: 1rem;
            margin: 0.5em 0 1.5em;
            font-family: 'OpenSans-SemiBold', sans-serif;
            color: $accent-color
          }

          .bio {
            font-family: 'NeueHaasUnicaPro-Regular', sans-serif;
            color: #000;
            font-size: 1rem;
          }
        }

        .picture {
          flex: 0 0 auto;
          max-width: 20%;
          margin: 2rem 0 2rem auto;
          text-align: right;

          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }

    &.our-name {

      .background {
        background: #fff;
      }

      .content {

        .text-section {

          .text {
            padding-top: 8rem;
            display: flex;
            flex-direction: row;
            max-width: 100% !important;

            .text-content {
              flex: 1;
              padding-right: 4vw;
            }

            .picture {
              flex: 0 0 auto;
              max-width: 30%;
              margin: 2rem 0 2rem auto;

              img {
                max-width: 100%;
                max-height: 100%;
              }
            }
          }
        }

        .big-title {
          position: absolute;
          top: 0.8em;
          left: 0;
          right: 0;
          font-size: 8rem;
          line-height: 8rem;
          color: rgba(0, 0, 0, 0.1);
          padding-left: 4rem;
        }
      }
    }

    @include media-query(medium) {

      &.intro {

        .content {
          justify-content: center;
          align-items: center;
          padding-left: 0;
          padding-bottom: 0;

          .section-header {
            text-align: center !important;
          }

          .section-title {
            text-align: center !important;
          }
        }
      }

      &.biography {

        .content {
          display: flex;
          flex-direction: column-reverse;
          justify-content: stretch;
          align-items: flex-start;

          .text {
            padding: 0 3rem 3rem;
          }

          .picture {
            max-width: 300px;
            margin: 2rem;
          }
        }
      }

      &.our-name {

        .content {

          .text-section {

            .text {
              padding-top: 0;
              flex-direction: column-reverse;

              .text-content {
                padding-right: 4vw;
                align-items: flex-start;
              }

              .picture {
                max-width: 300px;
                margin: 2rem;

                img {
                  max-width: 100%;
                  max-height: 100%;
                }
              }
            }
          }

          .big-title {
            display: none;
          }
        }
      }
    }
  }

  .loaded {

    .intro {

      .section-header {
        @include animation(fadeIn 1s $default-ease 0s 1 forwards);
      }

      .section-title {
        @include animation(fadeIn 1s $default-ease 200ms 1 forwards);
      }
    }
  }
</style>
